/**
 * Normalize a string by replacing dashes with spaces and capitalizing only the first letter
 * @param text - The string to normalize
 * @returns The normalized string
 */
export const normalizeText = (text: string): string => {
  if (!text) return "";

  const textWithoutDashes = text.replace(/-/g, " ");
  return textWithoutDashes.charAt(0).toUpperCase() + textWithoutDashes.slice(1);
};
